import { getMetricEventHealthByEventKeyAndDataSource } from '@gonfalon/openapi/operations/getMetricEventHealthByEventKeyAndDataSource';

import { createQueryOptions } from '../internal/createQueryOptions';

export const getMetricHealthResultQuery = createQueryOptions(getMetricEventHealthByEventKeyAndDataSource);
